export default __webpack_public_path__ + "static/media/wallpaper_bg5.17c5f288.png";